export default __webpack_public_path__ + "static/media/chart.95ce533c.png";